import { Title as MantineTitle, type TitleProps } from "@mantine/core";
import { CSSProperties, FunctionComponent, PropsWithChildren } from "react";

type Props = TitleProps & {
  order?: 1 | 2 | 3 | 4 | 5 | 6;
  style?: CSSProperties;
  color?: string;
};

export const Title: FunctionComponent<PropsWithChildren<Props>> = ({
  order = 5,
  children,
  style = {},
  color,
  ...rest
}) => {
  return (
    <MantineTitle order={order} style={style} c={color} {...rest}>
      {children}
    </MantineTitle>
  );
};
